import React from "react";
import { LivechatSubjectType } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import useProduceConsumeController from "./useProduceConsumeController";
import ConferenceView from "../ConferenceView";

interface Props {
  livechatSubject: Subject<LivechatSubjectType>;
  conferenceUuid: string;
  ownerId: string;
  onClose: () => void;
}

export default function ConferenceStreamController({ livechatSubject, conferenceUuid, ownerId, onClose }: Props) {
  const {
    threadId,
    userList,
    produceMediaConstraints,
    loading,
    token,
    audioInputs,
    videoInputs,
    users,
    me,
    streamStartedDate,
    isConferenceOwner,
    onChangeConstraints,
    onCloseStream,
    toggleMuteUser,
    permissions,
  } = useProduceConsumeController(livechatSubject, ownerId);

  return (
    <ConferenceView
      threadId={threadId}
      conferenceUuid={conferenceUuid}
      loading={loading}
      userList={userList}
      token={token}
      showConfirmationExit
      users={users}
      me={me}
      isConferenceOwner={isConferenceOwner}
      managedConstraints={produceMediaConstraints}
      permissions={permissions}
      audioInputs={audioInputs}
      videoInputs={videoInputs}
      streamStartedDate={streamStartedDate}
      muteUser={toggleMuteUser}
      onChangeConstraints={onChangeConstraints}
      onCloseConference={onClose}
      onCloseStream={onCloseStream}
    />
  );
}
